import {useEffect} from 'react';

import appService from '../services/appService';

const usePWAStatusTracker = () => {
    useEffect(() => {
        const mediaQuery = window.matchMedia('(display-mode: standalone)');

        mediaQuery.addEventListener('change', appService.updatePWAStatus);
        return () => mediaQuery.removeEventListener('change', appService.updatePWAStatus);
    }, []);
};

export default usePWAStatusTracker;
